import React from 'react'
import AnonymousView from '../anonymous-view'

const AnonymousViewEs = () => {
    return <AnonymousView languageCode="es" />
}

export default AnonymousViewEs
